export const getDefaultLayoutSettings = () => {
    return {
        accentColor: "#DE383C",
        accentDarkColor: "#c83236",

        fontFamily: "Lato",

        fontHeaderMenuCategorySize: "20px",
        fontHeaderMenuSubCategorySize: "16px",
        fontMenuSubCategorySize: "45px",
        fontTileArticleTitleSize: "20px",

        fontGeneralColor: "#151515",
        fontNegativeColor: "#FFFFFF",
        fontHeaderColor: "#FFFFFF",

        backgroundGeneralColor: "#FFFFFF",
        backgroundTileColor: "#E5E8F1",

        buttonColor: "#FFFFFF",
        buttonAccentColor: "#3E3E3E"
    }
}